import { graphql, readInlineData } from "react-relay";

import type { articleUtilsArticle$key } from "~/queries/__generated__/articleUtilsArticle.graphql";

export const useArticleUtils = () => {
  const getArticleType = (reference: articleUtilsArticle$key) => {
    const article = readInlineData(
      graphql`
        fragment articleUtilsArticle on Article @inline {
          types {
            value {
              entityId
            }
          }
        }
      `,
      reference,
    );
    const [articleType] = article.types?.flatMap(type => type?.value) ?? [];
    return articleType?.entityId;
  };

  return {
    getArticleType,
  };
};
